// extracted by mini-css-extract-plugin
export default {"select":"SelectRegions_select__krQjm"};